import { render } from "./FpButton.vue?vue&type=template&id=2960bd6c&scoped=true"
import script from "./FpButton.vue?vue&type=script&lang=js"
export * from "./FpButton.vue?vue&type=script&lang=js"

import "./FpButton.vue?vue&type=style&index=0&id=2960bd6c&scoped=true&lang=scss"

import exportComponent from "/home/forge/mooz360.co.il/app-src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2960bd6c"]])

export default __exports__